// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> rr-living-landing-page-landing-page -> indian-hills-lp
// Generated: 2026-10-07T17:13:52.565Z
// Counts: 0 design, 4 content, 4 slot group, 2 collection binding, 3 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_knock=gp"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_knock=gp"
      }
    }
  },
  "hero.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 6
    }
  ]
};

export const styleOverrides = {};
